import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IUserData } from 'types';

import initialState from './initialState';

const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
    setIsDarkModeEnabled(state, { payload }: PayloadAction<boolean>) {
      state.isDarkModeEnabled = payload;
    },
    setUseOSThemeEnabled(state, { payload }: PayloadAction<boolean>) {
      state.useOsTheme = payload;
    },
    setUserData(state, { payload }: PayloadAction<Partial<IUserData>>) {
      state.user = {
        ...state.user,
        ...payload,
      };
    },
    logout(state) {
      state.user = initialState.user;
    },
  },
});

export default generalSlice;
